const global = window

inputs.alias.steps = 'tabs'

inputs.types.tabs = function (data, name, niceName, type, input, parent, inputWindow) {

    inputs.fn.tabs = {
        set(input, tab) {
            input = $(input);
            if (!input.hasClass('tabs')) {
                input = input.closest('.tabs');
            }

            if (typeof tab === 'object' && tab !== null) {
                tab = $(tab);
                if (tab.hasClass('tabs')) {
                    tab = tab.find('> .tabs__nav, > .tabs__nav__wrap > .tabs__nav');
                }
                if (tab.hasClass('tabs__btn')) {
                    tab = $('#'+tab.attr('aria-controls'))
                }
                if (!tab.hasClass('tabs__pane')) {
                    tab = tab.closest('.tabs__nav')
                }
                if (tab.hasClass('tabs__pane')) {
                    var paneId = tab.attr('id');
                    var btn = tab.parent().find('.tabs__nav').find('[aria-controls="'+paneId+'"], #btn-'+paneId+', #btn-'+tab.attr('data-id')+', #btn-'+tab.attr('name'));
                    if (btn.length) {
                        tab = btn.index();
                    } else {
                        tab = tab.index('.tabs__pane');
                    }
                }
                else {
                    tab = null;
                }
            } else if (tab !== null && tab !== undefined) {
                let targetPane = input.find('> .tabs__pane[data-id="' + tab + '"], > .tabs__pane[id="' + tab + '"], > .tabs__pane[value="' + tab + '"], > .tabs__pane[name="' + tab + '"]');
                if (!targetPane.length) {
                    targetPane = input.find('.tabs__pane').filter(function() {
                        return $(this).attr('data-id') == tab || $(this).attr('id') == tab || $(this).attr('value') == tab || $(this).attr('name') == tab;
                    });
                }
                if (targetPane.length) {
                    let paneId = targetPane.attr('id');
                    let btn = input.find('.tabs__nav').find('[aria-controls="' + paneId + '"], #btn-' + paneId + ', #btn-' + targetPane.attr('data-id') + ', #btn-' + targetPane.attr('name'));
                    if (btn.length) {
                        tab = btn.index();
                    } else {
                        tab = targetPane.index('.tabs__pane');
                    }
                } else if (!isNaN(tab)) {
                    tab = parseInt(tab, 10);
                }
            }

            if (input && tab !== null && tab !== undefined && tab >= 0) {
                input.tabs('option', 'active', tab);
            }
        },
    }

    data.activate = function(event, ui) {
        const panel = (ui && ui.newPanel) ? ui.newPanel : ui.panel;

        // Récupérer données de l'onglet
        const tabData = panel ? panel.data('data') : null;

        // Flex pour pleine hauteur
        if (panel && tabData && tabData.full) panel.css("display","flex");

        // Changer valeur
        const currentTab = $(input).find(' > ul .ui-tabs-active, > .tabs__nav__wrap > ul .ui-tabs-active');
        let activePane = (panel && panel.length) ? panel : $('#' + currentTab.attr('aria-controls'));
        if (!activePane.length) activePane = $(input).find('.tabs__pane').eq(currentTab.index());

        let tabVal = activePane.attr('value');
        if (tabVal === undefined || tabVal === null || tabVal === '') {
            tabVal = currentTab.index();
        }

        $(input).val(tabVal);
        $(input).attr('value', tabVal);

        // Hack IV
        if (panel) {
            panel.find('.iv, .iconGrid').each(function () {
                let tabIvPlugin = $(this).data('plugin_iconsView') || $(this).data('plugin');
                if (tabIvPlugin && tabIvPlugin.resize) {
                    tabIvPlugin.resize();
                }
            });
        }

        // Mise à jours grandeur de fenêtre
        if (tabData) {
            const newWidth = tabData.width
            const newHeight = tabData.height
            if (newWidth || newHeight) {
                const win = $.window.find(input)
                if (win) {
                    win.resize(newWidth, newHeight)
                    win.alignCenter()
                }
            }
        }

        // Couleur de l'onglet
        const tabColor = (tabData && tabData.color) || (activePane && (activePane.attr('color') || activePane.data('color'))) || (currentTab && (currentTab.attr('color') || currentTab.data('color')));
        if (tabColor) {
            $(input).css('--color-primary', tabColor);
        } else {
            $(input).css('--color-primary', '');
        }

        // Save tabs
        if ($(input).attr('name')) {
            if (tabVal !== undefined && tabVal !== null) global.selectedTabsRecords[$(input).attr('name')] = tabVal;
        }

        // Scroll tab into view if needed within .tabs__nav__wrap
        if (currentTab.length) {
            const tabWrap = currentTab.closest('.tabs__nav__wrap');
            if (tabWrap.length) {
                const wrapEl = tabWrap[0];
                const tabEl = currentTab[0];
                const wrapRect = wrapEl.getBoundingClientRect();
                const tabRect = tabEl.getBoundingClientRect();
                const offsetMargin = 30; // Marge supplémentaire ("un peu plus")

                if (tabRect.left < wrapRect.left) {
                    const scrollDiff = tabRect.left - wrapRect.left - offsetMargin;
                    wrapEl.scrollTo({
                        left: Math.max(0, wrapEl.scrollLeft + scrollDiff),
                        behavior: 'smooth'
                    });
                } else if (tabRect.right > wrapRect.right) {
                    const scrollDiff = tabRect.right - wrapRect.right + offsetMargin;
                    wrapEl.scrollTo({
                        left: Math.min(wrapEl.scrollWidth - wrapEl.clientWidth, wrapEl.scrollLeft + scrollDiff),
                        behavior: 'smooth'
                    });
                }
            }
        }

        // Apply behavior
        if (panel) BEHAV.apply(panel, 'show');

        // Resize trigger
        window.dispatchEvent(new Event('resize'));

        // Change event
        $(input).change();
    };

    input.tabs({
        activate: data.activate,
        create(event, ui) {
            const currentTab = $(this).find(' > ul .ui-tabs-active, > .tabs__nav__wrap > ul .ui-tabs-active');
            const activePane = $('#' + currentTab.attr('aria-controls'));
            let tabVal = activePane.attr('value');
            if (tabVal === undefined || tabVal === null || tabVal === '') {
                tabVal = currentTab.index();
            }

            $(this).val(tabVal);
            $(this).attr('value', tabVal);

            // Load saved tab
            const loadTabRecord = global.selectedTabsRecords[$(input).attr('name')];
            if ($(input).attr('name') && loadTabRecord !== undefined && loadTabRecord !== null) {
                $(input).tabs('option', 'noAnimation', true);
                inputs.fn.tabs.set($(input), loadTabRecord);
                $(input).tabs('option', 'noAnimation', false);
            }

            setTimeout(function() {
                global.noQ = true
                data.activate(event, ui);
                global.noQ = false
            }, 100)

            if ($(event.target).find('.tabs__nav').children('.tabs__btn').length < 2) {
                $(event.target).find('.tabs__nav').addClass('tabs__nav--notabs')
                if ($(event.target).find('.tabs__nav > .tabs__addon').length) {
                    $(event.target).find('.tabs__nav > .tabs__btn').hide()
                }
                else {
                    $(event.target).find('.tabs__nav').hide()
                }
            }
        },
        beforeLoad: function( event, ui ) {
            // disable AJAX loading
            event.preventDefault();
        }
    })
    input.tabs("option", "classes.ui-tabs", "tabs");
    input.tabs("option", "classes.ui-tabs-nav", "tabs__nav");
    input.tabs("option", "classes.ui-tabs-panel", "tabs__pane");
    input.tabs("option", "classes.ui-tabs-tab", "tabs__btn");
    return data
}
